import { Colors, ERROR_ANIMATION_OPTIONS, FOOD_LOOP_ANIMATION_OPTIONS, LOADING_ANIMATION_OPTIONS, SUCCESS_ANIMATION_OPTIONS, Sizes, States } from './constants';
import Animation from './Animation';
import { LoadingRoot } from './styles';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemingContext } from '@doordash/design-language';
import { getAllPropCasesForColors } from '@doordash/utilities';

var animationForState = function animationForState(state) {
  switch (state) {
    case States.FoodLoop:
      return FOOD_LOOP_ANIMATION_OPTIONS;

    case States.Error:
      return ERROR_ANIMATION_OPTIONS;

    case States.Success:
      return SUCCESS_ANIMATION_OPTIONS;

    case States.Loading:
    default:
      return LOADING_ANIMATION_OPTIONS;
  }
};

var keyForState = function keyForState(state) {
  switch (state) {
    case States.FoodLoop:
      return 'FOOD_LOOP';

    case States.Error:
      return 'ERROR';

    case States.Success:
      return 'SUCCESS';

    case States.Loading:
    default:
      return 'LOADING';
  }
};

var Loading = function Loading(_ref) {
  var state = _ref.state,
      color = _ref.color,
      size = _ref.size,
      _onAnimationEnd = _ref.onAnimationEnd,
      _onAnimationLoopEnd = _ref.onAnimationLoopEnd;
  var theme = React.useContext(ThemingContext);
  return React.createElement(LoadingRoot, {
    color: color || theme.Colors.LoadingDefault
  }, React.createElement(Animation, {
    key: keyForState(state),
    options: animationForState(state),
    width: size,
    height: size,
    onAnimationEnd: function onAnimationEnd() {
      return _onAnimationEnd(keyForState(state));
    },
    onAnimationLoopEnd: function onAnimationLoopEnd() {
      return _onAnimationLoopEnd(keyForState(state));
    }
  }));
};

Loading.Sizes = Sizes;
Loading.States = States;
Loading.Colors = Colors;
Loading.propTypes = {
  size: PropTypes.oneOf(Object.values(Loading.Sizes)),
  state: PropTypes.oneOf(Object.values(Loading.States)),
  color: PropTypes.oneOf(getAllPropCasesForColors(Object.values(Loading.Colors))),
  onAnimationEnd: PropTypes.func,
  onAnimationLoopEnd: PropTypes.func
};
Loading.defaultProps = {
  size: Loading.Sizes.Medium,
  state: Loading.States.Loading,
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationLoopEnd: function onAnimationLoopEnd() {}
};
export default Loading;